import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const COUNTER_VISIBLE_RATIO = 0.9;

export const TOUCH_MEDIA = `@media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px), (pointer: coarse)`;
